@if (images()) {
  <div class="flex flex-row gap-2">
    @for (image of images(); track $index) {
      <ng-container
        *ngTemplateOutlet="filePreview; context: { src: image.src$ | async, alt: image.name }"
      ></ng-container>
    }
  </div>
}

@if (bpmnFiles()) {
  <div class="flex flex-row gap-2">
    @for (bpmn of bpmnFiles(); track $index) {
      <ng-container
        *ngTemplateOutlet="
          filePreview;
          context: { src: './assets/bpmn_thumb_full.svg', alt: bpmn.name }
        "
      ></ng-container>
    }
  </div>
}

<ng-template
  #filePreview
  let-src="src"
  let-alt="alt"
>
  <div class="w-[96px] h-[108px] overflow-hidden rounded-lg">
    <p-image
      [alt]="alt"
      [src]="src"
      width="96px"
      height="108px"
      imageClass="min-w-[96px] w-auto min-h-[108px] h-auto object-cover"
    />
  </div>
</ng-template>
